import React, { useState, useEffect } from 'react' 
import { Link , useNavigate} from 'react-router-dom';

import "datatables.net-dt/js/dataTables.dataTables";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import swal from "sweetalert";
import axios from "axios";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css


export default function Userslist() {
  const nav = useNavigate()
  const [users, setUsers] = useState([]);
  useEffect(() => {
    getUsers();
  }, []);
  
  const getUsers = async () => {
    await axios
      .get(process.env.REACT_APP_API_KEY + "api/admin/api-users",
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      })
      .then(function (response) { 
        //Check for Authorized
        if(response.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }

        setUsers(response.data);
        
      })
      .catch(function (error) {        
        console.log(error);
      });
  };

  //Update
  const handleClick = async (event) => {
    confirmAlert({
      title: "Confirm to Action",
      message: "Are you sure to update status of this User.",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            await axios.get(process.env.REACT_APP_API_KEY+'api/admin/user-status/'+event,
              {
                headers: {
                "Content-type": "Application/json",
                "Authorization": localStorage.getItem("token")
                }   
              }
              ).then(function (response) {
                //Check for Authorized
                // console.log("======--->", response)
                if(response.data.code == 403){
                  localStorage.clear();
                  nav('/admin/login');
                }
              if(response.status===200)
              {
                swal({
                  title: "Status",
                  text: "Status Updated Successfully!",
                  icon: "success",
                  button: "Okay",
                });
              }
              getUsers();
            })
            .catch(function (error) {
              console.log(error);
            });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

    const deleteUser = async (id) => {
    
      confirmAlert({
        title: "Confirm to Delete",
        message: "Are you sure to delete User.",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              await axios
                .get(process.env.REACT_APP_API_KEY+"api/admin/user-delete/" + id,
                {headers: {
                  "Content-type": "Application/json",
                  "Authorization": localStorage.getItem("token")
                  }   
                }
                )
                .then(function (response) {
                  //Check for Authorized
                  if(response.data.code == 403){
                    localStorage.clear();
                    nav('/admin/login');
                  }

                  if (response.data.code == 200){
                    console.log(">>>>",response);
                    swal({
                      title: "Wow!",
                      text: response.data.message,
                      icon: "success",
                      button: "Okay",
                    });
                    getUsers();
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    };

    //initialize datatable
  useEffect(() => {
    setTimeout(function () {
      $("#myTable").DataTable({
        bDestroy: true,
        fixedHeader: true,
        pagingType: "full_numbers",
        pageLength: 10,
        processing: true,
        dom: "Bfrtip",
  
        select: true,
      });
    }, 1000);
  }, []);

  return (
  <div class="body flex-grow-1 px-3">
    <div className="wrapper">
      <div className="wrapper">  
        <div className="content-wrapper">
          <h5 className="my3">
            User Management
            <Link className="btn btn-primary " to="/admin/api-users/add">Add User</Link>
          </h5>
          
          <table id="myTable" className="table table-striped my-3">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Contact</th>
                <th scope="col">Token</th>
                <th scope="col">Status</th>
                <th scope="col" style={{'width' : '15%'}}>Action(s)</th>
              </tr>
            </thead>
            <tbody>

              { users.map((user, index) => (
                <tr key={user.id}>
                  <td>{++index}</td>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.phone_number}</td>
                  <td>{user.api_token?user.api_token:'-'}</td>
                  <td>{user.status}</td>
                  
                  <td className='d-flex'>
                    <Link className="btn btn-success custom-btn" to={{ pathname: "/admin/api-users/edit" }} state={{ id: user.id }} title="Edit" >
                      <i className="fas fa-edit"></i>
                    </Link>
                    &nbsp;
                    <button className="btn btn-info custom-btn" onClick={() => { handleClick(user.id); }} title={user.status}>
                    <i className={user.status==='Active' ? 'fas fa-toggle-on' : 'fas fa-toggle-off'}></i>
                    </button>
                    &nbsp;
                    <button type="button" className="btn btn-danger custom-btn"
                      onClick={() => {
                        deleteUser(user.id);
                      }}
                      title="Delete"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div> 
  </div>
  )
}